// extracted by mini-css-extract-plugin
export var attachment = "_qz-a";
export var emailContainer = "_qz-4";
export var emailContentPaddedContainer = "_qz-b";
export var emailHeader = "_qz-6";
export var emailIframe = "_qz-3";
export var emailInfoIcon = "_qz-9";
export var emailShortenedSummary = "_qz-e";
export var infoDropdown = "_qz-0";
export var infoRowBoundedContent = "_qz-d";
export var internal = "_qz-5";
export var merchant = "_qz-8";
export var messageInputContainer = "_qz-h";
export var normal = "_qz-7";
export var replyCard = "_qz-f";
export var subtleButton = "_qz-1";
export var subtleButtonIconContainer = "_qz-2";
export var toggleViewRepliesButton = "_qz-c";
export var wrappingText = "_qz-g";